import { FormattedMessage } from 'react-intl';
import Image from 'next/image';
import { ProductCertificateType } from './product-certificate-type';
import { ProductLineItemProps } from './types';

export const ProductLineItem = ({
  item: { name: title, variant },
}: ProductLineItemProps) => (
  <div className="product-line-item">
    <div className="line-item-img embed-responsive embed-responsive-16by9">
      {variant?.images?.[0] && (
        <Image
          className="product-thumbnail"
          src={variant.images[0]}
          alt=""
          width={320}
          height={180}
          style={{ objectFit: 'cover' }}
        />
      )}
    </div>

    <div>
      <h3 className="m-0 h6">
        <FormattedMessage
          id="payment.form.cart.item.title"
          defaultMessage="{title}"
          description="Title for the Product Cart Item"
          values={{ title }}
        />
      </h3>
      <ProductCertificateType certificateType={variant?.attributes?.mode} />
    </div>
  </div>
);
